import { useTranslation } from 'react-i18next';

import { useCafe3dStore } from '@/stores/cafe3dStore';

export function EnergyEmptyState() {
  const { t } = useTranslation();
  const energy = useCafe3dStore((s) => s.energy);

  if (energy > 0) return null;

  return (
    <div className="absolute inset-x-4 top-1/3 z-20 pointer-events-auto">
      <div className="bg-cream-50/95 backdrop-blur rounded-2xl p-5 border border-coffee-700/15 shadow-xl text-center">
        <div className="text-4xl mb-2">☕</div>
        <h3 className="font-baloo font-bold text-xl text-coffee-900 mb-1">
          {t('gameplay.energy_empty_title')}
        </h3>
        <p className="text-sm text-coffee-700 mb-4">
          {t('gameplay.energy_empty_message')}
        </p>
      </div>
    </div>
  );
}
